<template>
  <locations-table :params="{ ids, account, allSelected, filters }"/>
</template>
<script>
import LocationsTable from '../Components/LocationsTable'

export default {
  name: 'LocationListTab',
  props: {
    ids: Array,
    account: String,
    allSelected: Boolean,
    filters: Object
  },
  data() {
    return {
      search: '',
      headers: [
        {
          text: 'Empresas',
          align: 'start',
          sortable: false,
          value: 'location_name'
        },
        { text: 'Código', value: 'store_code' },
        {
          text: 'Status',
          value: 'status'
        }
      ]
    };
  },
  components: {
    LocationsTable
  }
};
</script>
